import React from "react";

export enum RemitUploadAction {
  StartSubmission,
  SubmissionComplete,
  SubmissionError,
  DismissToast,
}

export enum RemitSubmissionState {
  Idle,
  Submitting,
  Complete,
  Error,
}

export interface RemitUploadState {
  submissionState: RemitSubmissionState;
  toastVisible: boolean;
  toastId: number;
}

export type RemitUploadContextType = {
  state: RemitUploadState;
  dispatch: React.Dispatch<RemitUploadAction>;
};

export const RemitUploadContext = React.createContext<
  RemitUploadContextType | undefined
>(undefined);

export const RemitUploadReducer = (
  state: RemitUploadState,
  action: RemitUploadAction
): RemitUploadState => {
  switch (action) {
    case RemitUploadAction.StartSubmission:
      return {
        ...state,
        submissionState: RemitSubmissionState.Submitting,
        toastVisible: true,
      };
    case RemitUploadAction.SubmissionComplete:
      return {
        ...state,
        submissionState: RemitSubmissionState.Complete,
        toastVisible: true,
      };
    case RemitUploadAction.SubmissionError:
      return {
        ...state,
        submissionState: RemitSubmissionState.Error,
        toastVisible: true,
      };
    case RemitUploadAction.DismissToast:
      return {
        ...state,
        submissionState: RemitSubmissionState.Idle,
        toastVisible: false,
        toastId: state.toastId + 1,
      };
    default:
      return state;
  }
};

export const useRemitUpload = (): RemitUploadContextType => {
  const context = React.useContext(RemitUploadContext);

  if (context === undefined) {
    throw new Error(
      "useRemitUpload must be used within RemitUploadContext's Provider"
    );
  }

  return context;
};
